import Grid from './Grid.component';
import Tile from './Tile';

Grid.Tile = Tile;
export default Grid;
